"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _propTypes = require("prop-types");
var _UserInfo = _interopRequireDefault(require("../UserInfo"));
var _ProductInfo = require("../ProductInfo");
var _platform = require("../../../helpers/platform");
var _dsWeb = require("@olxbr/ds-web");
var _dsIcons = require("@olxbr/ds-icons");
var _actions = require("../../../actions");
var _style = require("./style");
var _Settings = _interopRequireDefault(require("../../containers/Settings"));
var _selectors = require("../../../selectors");
var _MiniProfileRemoteComponent = _interopRequireDefault(require("../MiniProfileRemoteComponent"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function Header(_ref) {
  var closeChatAction = _ref.closeChatAction,
    redirectToAdAction = _ref.redirectToAdAction,
    redirectToUserProfileAction = _ref.redirectToUserProfileAction,
    focusChatInputAction = _ref.focusChatInputAction,
    _ref$isAdview = _ref.isAdview,
    isAdview = _ref$isAdview === void 0 ? false : _ref$isAdview,
    _ref$adStatus = _ref.adStatus,
    adStatus = _ref$adStatus === void 0 ? '' : _ref$adStatus,
    adSubject = _ref.adSubject,
    adPrice = _ref.adPrice,
    adImage = _ref.adImage,
    secondHidden = _ref.secondHidden,
    currentChat = _ref.currentChat,
    isKeyboardOpen = _ref.isKeyboardOpen,
    isLoading = _ref.isLoading;
  var onPressRedirectToUserProfile = function onPressRedirectToUserProfile() {
    redirectToUserProfileAction();
    focusChatInputAction();
  };
  var onPressRedirectToAd = function onPressRedirectToAd() {
    if (adStatus === 'active') {
      redirectToAdAction();
      focusChatInputAction();
    }
  };
  var formatedAdPrice = adPrice ? "R$ ".concat(adPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'), ",00") : '';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    secondHidden: secondHidden || !_platform.isMsite || isKeyboardOpen,
    isAdview: isAdview,
    isKeyboardOpen: isKeyboardOpen,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.FirstWrapper, {
      isAdview: isAdview,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.BackWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
          icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.ArrowLeft, {
            color: "var(--color-neutral-130)"
          }),
          label: 'Perfil',
          hideVisibleLabel: true,
          onClick: function onClick() {
            return closeChatAction(true);
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.UserInfoWrapper, {
        isAdview: isAdview,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserInfo["default"], {
          isAdview: isAdview,
          currentChat: currentChat
        })
      }), !isAdview && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.AdInfoWrapper, {
        onClick: onPressRedirectToAd,
        cursorPointer: adStatus === 'active',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductInfo.ProductInfo, {
          firstLine: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SubjectRight, {
            children: adSubject
          }),
          secondLine: adPrice ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: formatedAdPrice
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}),
          image: adImage,
          direction: 'rtl',
          isAdview: false,
          adStatus: adStatus
        })
      }), !isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ProfileWrapper, {
        isAdview: isAdview,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MiniProfileRemoteComponent["default"], {
          onPressRedirectToUserProfile: onPressRedirectToUserProfile,
          isAdview: isAdview,
          fallback: function fallback() {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
              icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.User, {
                color: "var(--color-secondary-100)"
              }),
              label: 'Perfil',
              hideVisibleLabel: true,
              onClick: onPressRedirectToUserProfile
            });
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SettingWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Settings["default"], {})
      }), isAdview && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.CloseWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
          icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.X, {
            color: "var(--color-secondary-100)"
          }),
          label: 'Fechar',
          hideVisibleLabel: true,
          onClick: function onClick() {
            return closeChatAction(false);
          }
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SecondWrapper, {
      secondHidden: secondHidden || !_platform.isMsite || isKeyboardOpen,
      onClick: onPressRedirectToAd,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductInfo.ProductInfo, {
        firstLine: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Subject, {
          children: adSubject
        }),
        secondLine: adPrice ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: formatedAdPrice
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}),
        image: adImage,
        direction: 'ltr',
        adStatus: adStatus
      })
    })]
  });
}
Header.propTypes = {
  closeChatAction: _propTypes.func.isRequired,
  isAdview: _propTypes.bool,
  redirectToAdAction: _propTypes.func.isRequired,
  redirectToUserProfileAction: _propTypes.func.isRequired,
  theme: _propTypes.object.isRequired,
  adStatus: _propTypes.string,
  focusChatInputAction: _propTypes.func.isRequired,
  adSubject: _propTypes.string,
  adImage: _propTypes.string,
  isKeyboardOpen: _propTypes.bool,
  isLoading: _propTypes.bool
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isKeyboardOpen: (0, _selectors.isKeyboardOpenSelector)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    closeChatAction: _actions.closeChat,
    redirectToAdAction: _actions.redirectToAd,
    redirectToUserProfileAction: _actions.redirectToUserProfile,
    focusChatInputAction: _actions.focusChatInput
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, mapDispatchToProps)((0, _styledComponents.withTheme)(Header));